import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bar" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showRatios)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", {
              style: _normalizeStyle({ color: _ctx.team1Color})
            }, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.team1Ratio) + "%", 1)
            ], 4),
            _createElementVNode("td", {
              style: _normalizeStyle({ color: _ctx.team2Color})
            }, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.team2Ratio) + "%", 1)
            ], 4)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      style: _normalizeStyle({ background: _ctx.team2Color}),
      class: "bar_right"
    }, [
      _createElementVNode("div", {
        style: _normalizeStyle({ background: _ctx.team1Color, width: _ctx.barWidth}),
        class: "bar_left"
      }, null, 4)
    ], 4)
  ]))
}